<!--
 * @description: data-permissions
 * @author: xuyiyuan
 * @date: 2023-08-17 17:52
-->
<template>
  <ls-metable
    ref="dataTable"
    :columns="columns"
    :data-list="dataList"
    :scroll="{ fixScreen: true }"
    :is-edit="false"
    :needAdd="false"
  >
    <template #remark="{ text, record }">
      <div v-if="record.purview==='QXFW0005'">
        <a-col v-for="(item,i) in record.definitionList" :key="i">
          <span>{{ item.businessName }}</span><span class="textRed">{{ item.operationName }}</span><span>{{ `【${ item.valueName.toString().replaceAll(',','、') }】` }}</span>
        </a-col>
      </div>
      <div v-else>{{ record.remark.replaceAll(',','，') }}</div>
    </template>
    <template #dataModifyTime="{text}">
      <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
    </template>
  </ls-metable>
</template>

<script>

import { selectTeamDataAuthList } from '@/api/system/businessGroup'

export default {
  name: "DataPermissions",
  props: {
    rowId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      columns: [
        {
          title: '系统',
          dataIndex: 'projectName',
          width: 80
        },
        {
          title: '菜单名称',
          dataIndex: 'menuName',
          width: 150
        },
        {
          title: '权限范围',
          dataIndex: 'attributeName',
          width: 100
        },
        {
          title: '说明',
          dataIndex: 'remark',
          scopedSlots: { customRender: "remark" }
        },
        {
          title: '更新人',
          dataIndex: "dataModifyUserName",
          width: 90
        },
        {
          title: '更新时间',
          dataIndex: "dataModifyTime",
          scopedSlots: { customRender: "dataModifyTime" },
          width: 150
        }
      ],
      dataList: []
    }
  },
  methods: {
    init () {
      const params = {
        rowId: this.rowId
      }
      selectTeamDataAuthList(params).then(res => {
        if (res.code === 200) {
          this.dataList = res.rows;
        }
      })
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style scoped lang="less">
.textRed{
  color:red;
  font-weight: bold;
}
</style>
